(() => {
  function setup(page) {
    if (page.hasAttribute('data-enhanced')) return;
    const form = page.querySelector('[data-rv-cart-form]');
    if (!form || typeof form.requestSubmit !== 'function') return;
    const update = form.querySelector('[data-rv-cart-update]');
    const feedback = form.querySelector('[data-rv-cart-feedback]');
    let busy = false;
    const message = text => { feedback.hidden = false; feedback.textContent = text; };
    const inputs = [...form.querySelectorAll('input[name="updates[]"]')];
    const sync = input => {
      const group = input.closest('[data-rv-cart-quantity]');
      const min = Number(input.dataset.nativeMin) || 1;
      group.toggleAttribute('data-at-minimum', Number(input.value) <= min);
      const plus = group.querySelector('[data-rv-cart-step="1"]');
      plus.disabled = input.readOnly || busy || Boolean(input.max && Number(input.value) + Number(input.step || 1) > Number(input.max));
    };
    const valid = input => {
      const n = Number(input.value), min = Number(input.dataset.nativeMin) || 1, step = Number(input.step) || 1;
      const ok = input.value !== '' && Number.isSafeInteger(n) && n >= 0 && (n === 0 || n >= min && n % step === 0) && (!input.max || n <= Number(input.max));
      input.setCustomValidity(ok ? '' : 'Choose a valid package quantity.');
      return ok;
    };
    inputs.forEach(input => {
      sync(input);
      input.addEventListener('input', () => { valid(input); sync(input); });
      input.addEventListener('change', () => {
        if (!busy && valid(input) && form.reportValidity()) form.requestSubmit(update);
      });
      input.closest('[data-rv-cart-quantity]').querySelectorAll('[data-rv-cart-step]').forEach(button => {
        button.addEventListener('click', () => {
          if (busy || input.readOnly) return;
          const n = Number(input.value), step = Number(input.step) || 1, min = Number(input.dataset.nativeMin) || 1;
          if (!Number.isSafeInteger(n)) { input.reportValidity(); return; }
          const direction = Number(button.dataset.rvCartStep);
          const next = direction < 0 && n <= min ? 0 : n + direction * step;
          if (next < 0 || input.max && next > Number(input.max)) return;
          input.value = String(next); valid(input); sync(input);
          if (form.reportValidity()) form.requestSubmit(update);
        });
      });
    });
    form.addEventListener('submit', event => {
      if (busy) { event.preventDefault(); return; }
      const quantitiesValid = inputs.map(valid).every(Boolean);
      if (!quantitiesValid || !form.reportValidity()) { event.preventDefault(); return; }
      // Keep native updates[] order, native checkout submitter and all successful fields.
      // Server-rendered prices are never recalculated in the browser.
      busy = true; form.setAttribute('aria-busy', 'true');
      form.querySelectorAll('[data-rv-cart-step]').forEach(button => { button.disabled = true; });
    });
    const apply = form.querySelector('[data-rv-cart-apply]'), code = form.querySelector('[data-rv-cart-code]');
    const applyCode = () => {
      if (busy) return;
      const value = code.value.trim();
      code.setCustomValidity(value ? '' : 'Enter a discount code.');
      if (!code.reportValidity()) return;
      try {
        const root = new URL(apply.dataset.rootUrl || '/', location.origin);
        const destination = new URL(root.pathname.replace(/\/?$/, '/') + 'discount/' + encodeURIComponent(value), location.origin);
        destination.searchParams.set('redirect', apply.dataset.cartUrl);
        if (destination.origin !== location.origin) throw new Error('Invalid discount destination');
        // Shopify validates the real code; no client-side discount or success state.
        location.assign(destination.href);
      } catch { message('Unable to open this code. You can enter it at checkout.'); }
    };
    apply.addEventListener('click', applyCode);
    code.addEventListener('input', () => code.setCustomValidity(''));
    code.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); applyCode(); } });
    page.setAttribute('data-enhanced', '');
  }
  document.querySelectorAll('[data-rv-cart-page]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rv-cart-page]').forEach(setup));
})();
